import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Shared "back to home" button used across all detail pages so every page's
// back button has the same shape, sizing, and hover behavior — only the
// colors and font are tuned per page to fit that page's theme.
const BackButton = ({ color = 'rgba(0,0,0,.55)', hoverColor = '#000', fontFamily = 'inherit', style }) => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const activeColor = hovered ? hoverColor : color;

  return (
    <button
      type="button"
      onClick={() => navigate('/', { state: { fromDetail: true } })}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Back to home"
      style={{
        appearance: 'none',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        background: 'transparent',
        font: `500 12px ${fontFamily}`,
        color: activeColor,
        border: `1px solid ${activeColor}`,
        borderRadius: 6,
        padding: '6px 13px',
        transition: 'border-color .18s ease, color .18s ease',
        ...style,
      }}
    >
      ← Back
    </button>
  );
};

export default BackButton;
